export default __webpack_public_path__ + "img/publication/publication2_1500.jpg";